// JavaScript code for acf_blocks/donate component
(($) => {

     "use strict";
     console.log("acf_blocks/donate scripts loaded...");

     $(document).ready(() => {
          if (!$('.acf-blocks-donate').length) {
               return;
          }

          // When clicked, show the donation form and hide the button
          $('.acf-blocks-donate .btn-activate-form').on('click', function() {
               $('.acf-blocks-donate .donate-form').slideDown();
               $(this).parent().hide();
          });

          // If the user sets a custom amount, updates the form with the new amount and disables the default options
          $('.enter-another-amount .input-field', '.acf-blocks-donate').on('change', function() {
               var amount = $(this).val();
               $('.donate-form .give-radio-level-custom').prop('checked', true);
               $('.donate-form input[name="give-amount"]').val(amount).trigger('blur');
               $('.donation-options .option').removeClass('active');
          });

          // When a donation option is clicked, update the form with the selected amount
          $('.donation-options .option', '.acf-blocks-donate').on('click', function() {
               var amount = parseFloat($(this).data('value'));
               if (!amount) return;
               $('.enter-another-amount .input-field', '.acf-blocks-donate').val(''); // Clear the custom amount field
               $('.donate-form .give-radio-level-custom').prop('checked', false);
               $('.donate-form input[name="give-amount"]').val(amount).trigger('blur');
               $('.donation-options .option').removeClass('active');
               $(this).addClass('active');
          });

          // When the page loads, select the first donation option
          $('.donation-options .option.active', '.acf-blocks-donate').trigger('click');
     });

})(jQuery);